import { ImageGalleryPlaceholderIcon } from "./icons";

type TransfersPlaceholderProps = {
  text?: string;
};

export function TransfersPlaceholder({
  text = "Select an image to preview"
}: TransfersPlaceholderProps) {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-gray-200">
      <div className="relative h-full w-full">
        <div className="relative h-full w-full rounded-lg bg-gray-200">
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="flex flex-col items-center space-y-6">
              <div className="relative">
                <ImageGalleryPlaceholderIcon className="h-42 w-48 text-gray-400" />
              </div>
              <p className="text-center text-sm font-semibold text-gray-800">{text}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
